import { Header, type NavItemInterface } from '../../base/Header'
import { Footer } from '../../base/Footer'
import { paths } from '@/configs/paths'

const navItems: NavItemInterface[] = [
  {
    label: 'Inventory',
    href: paths.deliveryStaff.path,
    activeMatchers: [paths.deliveryStaff.path, paths.outboundDetail.getHref('')]
  }
]

const DeliveryStaffLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex flex-col min-h-screen bg-[#F8FAFF]'>
      <Header navItems={navItems} />
      <main className='flex-1 p-5 pt-4 mt-14'>{children}</main>
      <Footer />
    </div>
  )
}

export default DeliveryStaffLayout
